import React from 'react';
import { Form, Space, Radio } from 'antd';

import * as recurrence from './../../../../constants/recurrence-constants';

const FrequencyItem = ({ onChange, selectedValue }) => {
  return (
    <Form.Item wrapperCol={{ span: 24 }} name={['rules', 'frequency']} rules={[{ required: true, message: 'Required' }]}>
      <Radio.Group noStyle className="recurrence-radio-group" value={selectedValue} onChange={($event) => onChange($event.target.value)}>
        <Space.Compact wrap="true" block="true" align="center" direction="horizontal">
          {recurrence.FREQUENCIES.map((freq, i) => (
            <Radio.Button style={{ width: Math.round(100 / recurrence.FREQUENCIES.length) + '%' }} key={i} value={freq.value}>
              {freq.name}
            </Radio.Button>
          ))}
        </Space.Compact>
      </Radio.Group>
    </Form.Item>
  );
};
export default FrequencyItem;
